import { render, staticRenderFns } from "./BestReviews.vue?vue&type=template&id=6f4d9466&"
import script from "./BestReviews.vue?vue&type=script&lang=ts&"
export * from "./BestReviews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports